'use client';
import React from 'react';
import styled from '@benzinga/themetron';

interface Props {
  hijack: boolean;
  doNotStopPropagation?: boolean;
  onHijackClick: () => void;
}

export const HijackComponent: React.FC<React.PropsWithChildren<Props>> = props => {
  const onDisplay = React.useCallback(
    (event: Event) => {
      if (!props.doNotStopPropagation) {
        event.stopPropagation();
      }
      const onHijackClick = props.onHijackClick;
      onHijackClick();
    },
    [props],
  );
  const [tableElement, setCoverElement] = React.useState<HTMLDivElement | null>();
  const onTableElementReady = React.useCallback((node: HTMLDivElement | null) => {
    setCoverElement(node);
  }, []);

  React.useEffect(() => {
    const val = tableElement;
    if (val) {
      val.addEventListener('click', onDisplay, true);
      val.addEventListener('change', onDisplay, true);
      return () => {
        val.removeEventListener('click', onDisplay, true);
        val.removeEventListener('change', onDisplay, true);
      };
    } else {
      return undefined;
    }
  }, [onDisplay, tableElement]);

  return React.useMemo(() => {
    if (props.hijack) {
      return <Wrapper ref={onTableElementReady}>{props.children}</Wrapper>;
    } else {
      return <>{props.children}</>;
    }
  }, [props.hijack, props.children, onTableElementReady]);
};

const Wrapper = styled.div`
  display: contents;
`;
